module.exports = __webpack_public_path__ + "static/20190822_141852-1f7a6e84b82dbf50348ff1143c5a7f32.jpg";